import urlJoin from 'url-join';
import { getCurrentBaseUrl } from '@@client/lib/url';
var storageKey = 'wkr:paypal-order-id';
export var savePaypalOrderId = function savePaypalOrderId(orderId) {
  localStorage.setItem(storageKey, orderId);
};
export var getPaypalOrderId = function getPaypalOrderId() {
  return localStorage.getItem(storageKey);
};
export var clearPaypalOrderId = function clearPaypalOrderId() {
  localStorage.removeItem(storageKey);
};
export var getPaypalReturnUrl = function getPaypalReturnUrl() {
  return urlJoin(getCurrentBaseUrl(), '/paypal');
};
export var getPaypalCancelUrl = function getPaypalCancelUrl() {
  return urlJoin(getCurrentBaseUrl(), '/paypal/cancel');
};